/**
 * Calendar holidays / awareness-days overlay + "Apply to posting schedule"
 * (lane C4) — Learn-Mode inline tips.
 *
 * Anchors: `components/calendar/EventChips.tsx` (social-calendar-events),
 * `components/calendar/CalendarOverlaySettingsButton.tsx`
 * (social-calendar-events-settings), `components/analytics/ApplyBestTimesButton.tsx`
 * (analytics-best-time-apply).
 */

import type { LearnTip } from "./types";

export const calendarEventsTips: LearnTip[] = [
  {
    key: "social-calendar-events",
    title: "Holidays & Awareness Days",
    body: 'Holidays, awareness days and industry days that fit this client, shown on the calendar so you can plan posts around them. Click one to see suggested hashtags and a post idea; "Create post" opens the composer with the idea filled in for you to rewrite.',
  },
  {
    key: "social-calendar-events-settings",
    title: "Choose Which Holidays Show",
    body: "Pick which kinds of days appear on this client's calendar — federal holidays, popular observances, awareness months, and industry days such as food & drink, beer, wellness, real estate or local business. Saved per client; turn them all off to hide the overlay.",
  },
  {
    key: "analytics-best-time-apply",
    title: "Apply to Posting Schedule",
    body: "Turns the best-time grid into weekly posting slots for one of this client's accounts. You see the proposed times first — the best tested times, typical times for the network where there isn't enough history yet, and a few untested hours kept for learning — and nothing is saved until you apply.",
  },
];
